export const GTMPush = <T extends DataLayerElement = any>(data: T) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push(data);
};
